import createVueComponent from '../createVueComponent';

const ArrowBigUp = createVueComponent('ArrowBigUpIcon', [
  ['path', { d: 'M9 18v-6H5l7-7 7 7h-4v6H9z', key: '1x06kx' }],
]);

export default ArrowBigUp;
